import { AppVersionModal } from "UIPalette/AppVersionModal/AppVersionModal";
import { BottomNavBar } from "./Components/BottomNavBar";
import { Outlet } from "react-router-dom";
import { TopNavBar } from "./Components/TopNavBar";
import { WhatsNewModal } from "UIPalette/WhatsNewModal/WhatsNewModal";
import { useAppLocation } from "../../hooks/useAppLocation";
import classNames from "classnames";
import { Container } from "shared/UI/LayoutComponents/LayoutComponents";
import { useMatchMedia } from "shared/UI/Hooks/useMatchMedia";
import { ResponsiveBreakpoints } from "shared/UI/ResponsiveBreakpoints";
import { FeedbackModal } from "UIPalette/AppReview/FeedbackModal/FeedbackModal";
import { WisdomAINavButton } from "./Components/WisdomAINavButton";

export const AppLayout = () => {
  const isMobileApp = window.flutter_inappwebview;
  const largerDisplay = useMatchMedia(ResponsiveBreakpoints.Desktop);
  const { isNotMainRoute, isHomePage, shouldRenderWithContainer, shouldRenderWithBottomBar, backIcon } = useAppLocation();

  const isMobilePage = !!isMobileApp && isNotMainRoute;
  const isTabletHome = !!isMobileApp && largerDisplay && isHomePage;
  const isDesktopDisplay = !isMobileApp && largerDisplay;

  const content = (
    <>
      <AppVersionModal />
      <WhatsNewModal />
      <FeedbackModal />
      <Outlet />
    </>
  );

  return (
    <div className="flex flex-col min-h-screen gap-0 overflow-clip">
      <TopNavBar isNotMainRoute={isNotMainRoute} backIcon={backIcon} />
      <main role="main">
        <div className={classNames({ "pb-12": isMobilePage && shouldRenderWithBottomBar })}>
          {shouldRenderWithContainer ? <Container>{content}</Container> : content}
        </div>
      </main>
      {<BottomNavBar hideBottomNav={!shouldRenderWithBottomBar || isMobilePage || isTabletHome || isDesktopDisplay} />}
      {isDesktopDisplay && shouldRenderWithBottomBar && (
        <WisdomAINavButton className="fixed right-6 bottom-6 z-HIGH" />
      )}
    </div>
  );
};
